
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface BikeInstructionDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function BikeInstructionDialog({ isOpen, onClose }: BikeInstructionDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Правила использования велосипеда</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm">
          <div>
            <h3 className="font-bold text-destructive mb-2">❌ Что запрещено:</h3>
            <ul className="space-y-2">
              <li className="flex gap-2">
                <span className="text-destructive">❗</span>
                <span>Самостоятельный ремонт или вскрытие аккумулятора — штраф 30 000 ₽.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-destructive">❗</span>
                <span>Передача велосипеда другим людям, сдача в субаренду — штраф 10 000 ₽.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-destructive">❗</span>
                <span>Изменение внешнего вида, наклейки, рисунки, тюнинг — штраф 10 000 ₽.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-destructive">❗</span>
                <span>Продление срока аренды без оплаты — штраф 1 000 ₽/день.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-destructive">❗</span>
                <span>Отказ от возврата или возврат не в том состоянии — возмещение ремонта, доп. штрафы.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-destructive">❗</span>
                <span>Просрочка аренды более 10 дней — Арендодатель имеет право изъять транспорт.</span>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-primary mb-2">📞 Важное:</h3>
            <ul className="space-y-2">
              <li>Все действия (продление, возврат, замена и т.д.) оформляются через личный кабинет на tuk-tuk.rent или через чат-бота.</li>
              <li>Фиксация состояния и видео могут быть обязательны при передаче и возврате.</li>
            </ul>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
